<div class="chat-panel-container">
  <div class="header">
    @if (loadingInquiry) {
      <dk-skeleton
        [skeletonConfig]="{
          size: 1,
          layout: 'horizontal',
          width: '60%',
          height: '32px',
        }"></dk-skeleton>
    } @else {
      <span class="title">
        {{ inquiry.platform + ' • ' + (inquiry.createdAt | utcToLocal: headerDateFormat) }}
      </span>
    }
  </div>
  <div class="content">
    <div class="messages-container" #messageContainer>
      @if (loadingInquiry) {
        <!-- Message skeleton items that match real message structure -->
        @for (item of [1, 2, 3]; track item) {
          <div class="message skeleton-message" [class.isByMe]="item % 2 === 0">
            <div class="message-content">
              <dk-skeleton
                [skeletonConfig]="{
                  size: item === 1 ? 3 : 2,
                  layout: 'vertical',
                  width: '100%',
                  height: '16px',
                }"></dk-skeleton>
            </div>
            <div class="footer" [class.isByDoktar]="item % 2 !== 0">
              <dk-skeleton
                [skeletonConfig]="{
                  size: 1,
                  layout: 'horizontal',
                  width: '80px',
                  height: '12px',
                }"></dk-skeleton>
            </div>
          </div>
        }
      } @else {
        @for (message of inquiry.inquiryCorrespondences; track message.id) {
          <div class="message-content-container">
            @if (!message.isByMe && message.correspondenceType != 'AI') {
              <div class="message-avatar">
                <dk-generic-seed-icon></dk-generic-seed-icon>
              </div>
            } @else if (!message.isByMe && message.correspondenceType == 'AI') {
              <div class="message-avatar">
                <dk-seed-icon-native></dk-seed-icon-native>
              </div>
            }
            <div class="message" [class.isByMe]="message.isByMe && message.correspondenceType != 'AI'">
              <div class="message-content">
                @if (message.correspondenceType == 'AI') {
                  @if (!message.inquiryContent && showTypingIndicator) {
                    <dk-typing></dk-typing>
                  } @else {
                    <div class="message-text markdown-content" [innerHTML]="renderedContents[message.id]"></div>
                  }
                } @else {
                  <span class="message-text">
                    {{ message.inquiryContent }}
                  </span>
                }
                @if (message.fileUrl != null && message.fileUrl != undefined) {
                  <div class="message-file">
                    <img [src]="message.fileUrl" alt="uploaded file" />
                  </div>
                }
              </div>
              <div class="footer" [class.isByDoktar]="!message.isByMe">
                <span>
                  {{ formatMessageDate(message.createdAt) + (message.isByMe ? '' : ' • ') }}
                  @if (!message.isByMe) {
                    {{
                      message.correspondenceType == 'AI'
                      ? ('doktar_app.communications.chat_response_by_ai' | translate)
                      : ('doktar_app.communications.chat_response_by_expert' | translate)
                    }}
                    @if(message.correspondenceType == 'AI') {
                      <dk-generic-seed-icon></dk-generic-seed-icon>
                      {{'| Doktar AI.'}}
                    } @else {
                      {{'| Doktar.'}}
                    }
                  }
                </span>
              </div>
            </div>
          </div>
          @if (message.isByMe && isMessageForwarded(message.id)) {
            <div class="message-content-container">
              <div class="message-avatar">
                <dk-seed-icon-native></dk-seed-icon-native>
              </div>
              <div class="message forwarded-message">
                <div class="message-content">
                  <span class="message-text">
                    {{ 'doktar_app.account.support.ai_response_not_found' | translate }}
                  </span>
                </div>
                <div class="footer isByDoktar">
                  <span>
                    {{ 'doktar_app.communications.chat_response_by_ai' | translate }}
                    <dk-generic-seed-icon></dk-generic-seed-icon>
                    {{'| Doktar AI.'}}
                  </span>
                </div>
              </div>
            </div>
          }
        }

        @if (inquiry.inquiryCorrespondences?.length === 0) {
          <div class="empty-messages">
            <span class="empty-title">{{ 'doktar_app.communications.no_chat_yet' | translate }}</span>
            <span class="empty-text">{{ 'doktar_app.communications.no_chat_yet_subtitle' | translate }}</span>
          </div>
        }
      }
    </div>
    <div class="chat-bar">
      @if (uploadedFileId) {
        <div class="uploaded-files">
          <div class="file-preview">
            <span class="file-name">{{ uploadedFile.name }}</span>
            <dk-button
              [icon]="'ph ph-x'"
              [size]="'medium'"
              [text]="true"
              [severity]="'secondary'"
              (click)="clearMessage()"></dk-button>
          </div>
        </div>
      }
      @if (informationBoxActive) {
        <span class="subtitle">
          {{ informationBoxText | translate }}
        </span>
      }
      @if(!hasForwardedMessage) {
        <form [formGroup]="messageForm" (ngSubmit)="sendMessage()" (keydown.enter)="sendMessage()">
          <div class="input-container row">
            <dk-button
              [icon]="'ph-bold ph-plus'"
              [size]="'medium'"
              [text]="false"
              [severity]="'secondary'"
              [disabled]="sendingMessage || loadingInquiry || isStreaming"
              (click)="openAttachPopover($event)"></dk-button>
            <dk-input
              col="8"
              name="message"
              [type]="'text'"
              style="flex: 1 0 0"
              [formGroup]="messageForm"
              [controlName]="'message'"
              [disabled]="sendingMessage || loadingInquiry || isStreaming"></dk-input>
            <dk-button
              [icon]="'ph ph-arrow-up'"
              [text]="false"
              [size]="'medium'"
              [severity]="'primary'"
              [disabled]="!canSendMessage"
              [loading]="sendingMessage"
              type="submit"></dk-button>
          </div>
        </form>
      }
    </div>
  </div>
</div>

<p-popover #uploadFilePopover [appendTo]="'body'">
  <div class="upload-file-popover">
    <p-fileUpload
      mode="basic"
      [chooseLabel]="'doktar_app.account.enterprise.contract.upload_file' | translate"
      [accept]="acceptedFileTypes"
      [maxFileSize]="maxFileSize"
      [auto]="true"
      [showUploadButton]="true"
      [showCancelButton]="false"
      (onSelect)="onFileSelect($event)"
      (onUpload)="onFileUpload($event)"
      (onError)="onFileUploadError($event)"
      [customUpload]="true"
      (uploadHandler)="customUploadHandler($event)"></p-fileUpload>
  </div>
</p-popover>
